const Form082TC = {
    stepName: {
        importantNotes: "重要提示",
        basicInformation: "基本資料",
        declaration: "聲明",
        confirmation: "確認",
    },
    tooltipList: {
        toopltip1:
            "1. 放取侍產假的日數最多為5個工作天，有關批核侍產假的詳情請參閱教育局通告第16/2015號。",
        toopltip2: "請刪去不適用者",
    },

    importantNotesContent: {
        // note: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        // a: "辦理與聘用有關的事宜；",
        // b: "處理發放薪金津貼及其他政府資助；",
        // c: "計算公積金的供款；",
        // d: "進行核數工作；",
        // e: "進行研究及統計資料，以便規劃教育服務；",
        // f: "處理有關教育專業人員發展的事宜；",
        // g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
        // note1: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        // note2: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        // note3: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        // note4: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
        title: "個人資料收集聲明",
        p_title: "收集個人資料的目的",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "處理、核實及查證就發還侍產假薪酬(只適用於已離職的教職員) 的申請；",
        p1_b: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
        p1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
        p1_f: "編製統計資料、研究及政府刊物；以及",
        p1_g: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》]。",

        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請。",

        p_title3: "可獲轉移資料者",
        p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        p3_c: "你曾就披露個人資料給予訂明同意；以及",
        p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

        p_title4: "查閱個人資料",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向有關高級學校發展主任提出，並寄交教育局網頁(https://www.edb.gov.hk/tc/contact-us/reo.html)所載區域教育服務處地址或電郵至 <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>。",

        termsConditions: "我已閱讀、理解並同意上述條款和條件。",
        iamStatement: "本人理解學校審批人需要擁有「智方便+」帳戶才能處理申請。",
    },
    schoolInformation: {
        title: "學校資料",
        label: {
            nameOfSchool: "學校名稱",
            schoolCode: "學校代碼",
            month: "月份",
            year: "年份",
        },
    },

    basicInformationContent: {
        title: "甲部 基本資料",
        paternityLeaveTitle: "教職員資料",
        applicantTitle: "放取侍產假的日期",
        salaryTitle: "薪酬",
        label: {
            name: "姓名",
            staffRefNo: "員工檔號",
            post: "職位",
            cesssationOfEmploymentDate: "離職日期",
            paternityLeaveFrom: "由",
            paternityLeaveTo: "至",
            noOfworkingDays: "日數(a)",
            monthlySalary: "月薪（元）(b)",
            dailySalary: "日薪（元）(c) = (b) ÷ 該月日數",
            totalAmountPerRow: "發還薪金總額（元）(d) = (c) x (a)",
            total: "總額（元）",
            leaveType: "無薪假期/年假",
            leaveOption: {
                noPay: "無薪假期",
                annual: "年假",
            },
            emolumentsAttachment: "薪酬收據",
            otherAttachment:
                "其他附件（例如學校來信、辭職信、出生證明、分娩日期、侍產假日期等）",
        },
    },
    declarationContent: {
        title: "乙部 聲明",
        label: {
            applicantType: "校監/校長",
            applicantTypeOption: {
                supervisor: "校監",
                schoolHead: "校長",
            },
            applicantName: "姓名",
            claimDate: "申請日期",
            contactPersonName: "聯絡人",
            telNo: "電話號碼",
            ssdo: "高級學校發展主任",
            beforeSSDOText: "副本送︰高級學校發展主任（",
            afterSSDOText: "）",
        },
        subTitle: "本人證實 –",
        textBeforeTooltip2:
            "本校已按照相關的通告處理有關教職員的侍產假事宜。該教職員在上述期間放取的侍產假因未能遞交相關證明文件，已以",
        textAfterTooltip2: "替代，其後他已補交相關的證明文件，並得到學校核實；",
        p2: "有關侍產假的薪酬已支付予相關的教職員。隨函附上有關收據，以供記錄存檔。",
    },
    errorMsg: {
        label: {
            noOfworkingDays: "日數",
            monthlySalary: "月薪",
            dailySalary: "日薪",
        },
    },
};
export default Form082TC;
